export default "__VITE_ASSET__DTKQUJji__"